import { render, staticRenderFns } from "./CardMenu.vue?vue&type=template&id=3277ff57"
import script from "./CardMenu.vue?vue&type=script&lang=js"
export * from "./CardMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports